import { render, staticRenderFns } from "./discounts.vue?vue&type=template&id=352cd720&scoped=true&"
import script from "./discounts.vue?vue&type=script&lang=js&"
export * from "./discounts.vue?vue&type=script&lang=js&"
import style0 from "./discounts.vue?vue&type=style&index=0&id=352cd720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352cd720",
  null
  
)

export default component.exports